import api from "@/services/api";
import { ENDPOINTS_ADMIN } from "@/services/endpoints";

export const listAdminUsers = () => api.get(ENDPOINTS_ADMIN.users).then((r) => r.data);

export const listAdminContracts = () => api.get(ENDPOINTS_ADMIN.contracts).then((r) => r.data);
